import React from 'react';
import { Button, Form } from 'react-bootstrap';
import IosSendOutline from 'react-ionicons/lib/IosSendOutline'
import ButtonLoading from '../../../../components/ButtonLoading';
import config from '../../../../constants/config';
import { ContactPersonT, JobT } from '../../../../types/Job';
import { AxiosInstance } from '../../../../utils/RequestMethods';

const initTemplate = `To schedule your move, go to [company_website] and login with the following credentials.

Email:  [client_email]
Temp Password: [temp_password]`
export type IFormSendBookingInfoProps = {
    job: JobT
    selectedContact: ContactPersonT | null
    referesh?(): void
}


const FormSendBookingInfo: React.FC<IFormSendBookingInfoProps> = (props) => {
    const [message, setMessage] = React.useState(initTemplate);
    React.useEffect(() => {

    }, []);
    const sendMessage = async (): Promise<string> => {
        let params = {
            message: message,
        }
        try {
            let res = await AxiosInstance.post(`${config.url.jobs}/${props?.job?.id}/send-booking-info`, params)
            if (res && res.data) {
                // setMessage("")
                if (props.referesh) {
                    setTimeout(() => {
                        props.referesh()
                    }, 100);
                }
                return "Booking info sent."
            }

        } catch (error) {
            throw error
        }

    }

    return (
        <div>
            <h3>Send Booking Info</h3>
            <Form>
                <Form.Group>
                    <Form.Label>Body</Form.Label>
                    <Form.Control
                        value={message}
                        as="textarea"
                        className="input-material"
                        rows={5} />
                </Form.Group>
                <ButtonLoading variant='success' onClickFetching={sendMessage}><strong><IosSendOutline color='white' />&nbsp;Send Booking Info</strong></ButtonLoading>

            </Form>
        </div>
    );
}

export default FormSendBookingInfo